import { PureComponent } from 'react';

import { isNonNullable, isNullable } from '@ipfabric/utils';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { DragSource } from 'react-dnd';

const tableRowSource = {
  beginDrag(props) {
    return {
      report: props.report,
    };
  },
  canDrag(props) {
    const { report, selectedGroup, reportsInGroup } = props;
    if (isNullable(selectedGroup)) {
      return true;
    }
    const reportId = report.id;
    const foundReport = reportsInGroup.find((r) => r.id === reportId);
    return !foundReport;
  },
};

function dragCollect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    canDrag: monitor.canDrag(),
  };
}

@DragSource('treeViewReport', tableRowSource, dragCollect)
export default class ReportItem extends PureComponent {
  static propTypes = {
    canDrag: PropTypes.bool.isRequired,
    connectDragSource: PropTypes.func.isRequired,
    foundResults: PropTypes.object,
    level: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    onDoubleClick: PropTypes.func.isRequired,
    preselectReport: PropTypes.string,
    query: PropTypes.string,
    report: PropTypes.object,
    selected: PropTypes.bool.isRequired,
  };

  render() {
    const {
      canDrag,
      connectDragSource,
      foundResults,
      level,
      onClick,
      onDoubleClick,
      preselectReport,
      query,
      report,
      selected,
    } = this.props;
    const highlighted =
      isNullable(preselectReport) &&
      isNonNullable(query) &&
      foundResults[report.webEndpoint]
        ? foundResults[report.webEndpoint].find((id) => id === report.id)
        : false;
    return connectDragSource(
      <li>
        <div
          className={classNames(
            'dashboard-color-form__tree-view-item-wrapper',
            'dashboard-color-form__tree-view-report-item-wrapper',
            canDrag &&
              'dashboard-color-form__tree-view-report-item-wrapper--drag',
            selected &&
              'dashboard-color-form__tree-view-report-item-wrapper--selected',
            highlighted &&
              'dashboard-color-form__tree-view-report-item-wrapper--highlighted',
          )}
          data-reportid={report.id}
          onClick={onClick}
          onDoubleClick={onDoubleClick}
        >
          {Array.apply(0, new Array(level + 2))
            .map((_v, i) => i)
            .map((v) => (
              <div
                key={v}
                data-reportid={report.id}
                className='dashboard-color-form__empty-space'
              />
            ))}
          <i
            className='fa-regular fa-file-lines mr-2'
            data-reportid={report.id}
          />
          {report.name}
        </div>
      </li>,
    );
  }
}
